import type { ICommand, ICommandHandler, IHttpClient } from '@/application/core';
import type { RetryRegistrationResult } from './retry-registration.types';

// Re-export types for consumers that import directly from this file
export type { RetryRegistrationRequest, RetryRegistrationResult } from './retry-registration.types';

// ============================================================================
// Command
// ============================================================================

export class RetryRegistrationFECommand implements ICommand<RetryRegistrationResult> {
  readonly type = 'RetryRegistrationFECommand' as const;
  constructor(
    public readonly sessionId: string,
    public readonly sessionType: 'registration' | 'upgrade',
    public readonly retryNotes: string
  ) {}
}

// ============================================================================
// Handler
// ============================================================================

export class RetryRegistrationFECommandHandler
  implements ICommandHandler<RetryRegistrationFECommand, RetryRegistrationResult>
{
  constructor(private readonly httpClient: IHttpClient) {}

  async handle(command: RetryRegistrationFECommand): Promise<RetryRegistrationResult> {
    const response = await this.httpClient.post<any>('/api/sales/retry-registration', {
      session_id: command.sessionId,
      session_type: command.sessionType,
      retry_notes: command.retryNotes,
    });

    // Transform response
    return {
      sessionId: response.session_id ?? response.sessionId,
      status: response.status,
      errorMessage: response.error_message ?? response.errorMessage,
      errorCheckpoint: response.error_checkpoint ?? response.errorCheckpoint,
    };
  }
}
